import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import Card from '../../components/Cards/Card';
import MainContainer from "../../components/container/MainContainer";
import CustomButton from '../../components/CustomButton/CustomButton';
import { getDetails } from '../../services/http/http.service';
import { useAppSelector } from '../../store/storeRequests';
import APIList from '../../utils/constants/APIList';
import BreadcrumbData from '../../utils/constants/BreadcrumbData.constants';
import { APIResponseCodes } from '../../utils/constants/keys.constants';
import StoreSelectors from '../../utils/constants/StoreSelectors.constants';
import './wishlist.css';
import { NavList } from '../../utils/constants/navigation';

const Wishlist = () => {

    const isUIMounted = useRef(false)
    const navigate = useNavigate()
    const { access } = useAppSelector(StoreSelectors.USER_STATE)

    const [data, setData] = useState([])

    const getWishlistData = async () => {
        const response = await getDetails(APIList.GET_ALL_WISHLIST, getWishlistData)
        if (response.statusCode === APIResponseCodes.SUCCESS) {
            setData(response.data)
        }
    }

    useEffect(() => {
        if (!isUIMounted.current) {
            getWishlistData()
        }
        isUIMounted.current = true
    }, [])

    const wishlistDataCallback = (modData: any) => {
        setData(modData)
    }

    return (
        <MainContainer>
            <Breadcrumb routes={BreadcrumbData.wishlist} />

            <h2 className='text-capitalize mf-active-header'>My Wishlist</h2>

            {
                data.length === 0 &&
                <div className="text-center py-3 no-data-with-view">
                    <p className="mb-0 weight-500 font-14 text-primary-color mb-2">Your wishlist is empty...</p>
                    <button onClick={() => navigate(NavList.MARKET_PLACE)} className="border-0 font-13 text-sec-color weight-500">View APIs {'>'}</button>
                </div>
            }

            <div className="mf-wishlist-page">
                <Card from='wishlist' list={data} callbackFunction={wishlistDataCallback} />
            </div>

            {
                data.length !== 0 && (access.hasUATAccess !== false && access.hasProdAccess !== false) &&
                <div className="wishlist-nav-btn">
                    <CustomButton type='button' size='md' onClick={() => navigate(NavList.CART)}> Return to Cart </CustomButton>
                </div>
            }

        </MainContainer>
    )
}

export default Wishlist